import { ILab } from '../../views/labs/models/Labs';
import { IUserDetail } from '../../views/user-management/models/user-mgmt';

// The labs a user can make their active lab: their own lab memberships,
// excluding only soft-deleted labs. Build status is intentionally NOT filtered
// — the switcher/picker should let a user into any of their labs, including
// ones still provisioning. Shared by the lab-selection landing page and the
// header lab switcher so both stay in sync.
export function selectableLabsFor(labs: ILab[], user: IUserDetail | null): ILab[] {
  const membershipIds = new Set((user?.lab_memberships ?? []).map((lab) => lab.id));
  return labs.filter((lab) => lab.active !== false && membershipIds.has(lab.id));
}
